import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetVendorId } from "../../hooks/global/User";
import VendorSettings from "./VendorSettings";
import ProfileSettings from "./ProfileSettings";
import LoadingSpinner from "../global/LoadingSpinner";
import { useGetVendor } from "../../hooks/vendors/Vendors";
import { useGetProfile } from "../../hooks/profiles/Profiles";

function CompanySettings() {
  const vendorId = useGetVendorId();
  const { t } = useTranslation();

  const { data: vendor, isLoading: isLoadingVendor, isError: isErrorVendor, refetch: refreshVendor } = useGetVendor();
  const { data: profiles, isLoading: isLoadingProfiles, isError: isErrorProfiles, refreshProfiles } = useGetProfile();


  if (isLoadingVendor || isLoadingProfiles) return <LoadingSpinner />;
  if (isErrorVendor || isErrorProfiles) return 'An error has occurred: ' + isErrorVendor.message + ' ' + isErrorProfiles.message;


  return (
    <div id="artur-profileAdditional" className="mt-0">
      <Container>
        <Row>
          {vendor && profiles && (
            <div className=" col-md-12 col-md-offset-2 content editMe vendor">

              <h2>
                {t("admin.set.h1")}
                <span className="settings"></span>
              </h2>
              <Col>
                <VendorSettings vendor={vendor} refreshVendor={() => refreshVendor()} />

                <ProfileSettings profiles={profiles} refreshProfiles={() => refreshProfiles()} />
              </Col>
            </div>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default CompanySettings;
